/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Pill_WindInputs */

const en_ui_color_by_pill_wind = /** @type {(inputs: Ui_Color_By_Pill_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wind`)
};

const de_ui_color_by_pill_wind = /** @type {(inputs: Ui_Color_By_Pill_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wind`)
};

/**
* | output |
* | --- |
* | "Wind" |
*
* @param {Ui_Color_By_Pill_WindInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_pill_wind = /** @type {((inputs?: Ui_Color_By_Pill_WindInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Pill_WindInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_pill_wind(inputs)
	return de_ui_color_by_pill_wind(inputs)
});